import { s as t, _ as o } from "./chunk-JJ6VZ5V7-dcb0df39.mjs";
import * as e from "react";
import { s as m, c as i } from "./lib-ed2ec51e.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var r = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  o({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, l),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M16 0v16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m8 3.867-.784.545.277-.914-.761-.577.955-.02L8 2l.313.902.955.02-.76.576.276.914L8 3.867ZM4.667 6.533l-.784.546.276-.914-.76-.577.954-.02.314-.901.313.902.955.019-.761.577.276.914-.783-.546Zm6.667-.666-.784.545.276-.914-.76-.577.954-.02.314-.901.313.902.955.02-.761.576.276.914-.784-.545Zm-2.001 2.4-.392.272.139-.457-.38-.288.477-.01.156-.45.157.45.477.01-.38.288.138.457-.392-.272Zm-1 4.066-.98.682.346-1.142-.95-.721 1.192-.025L8.333 10l.392 1.127 1.193.025-.95.72.345 1.143-.98-.682Z",
      clipRule: "evenodd"
    }
  )
), p = m(r)`
  ${t}
  ${i}
`, Z = p;
export {
  Z as default
};
